import {
  type EditToolLayoutValues,
  type FrameType,
  type TourStep,
  TourStepEventType,
  TourStepType,
} from '@carboncopyco/types';
import { DEFAULT_STEP_CONTENT } from '../constants';
import { buildDefaultTooltipConfigObject } from './tooltipConfig';

export const getInitialStep = (
  isLast: boolean,
  xpath: string,
  frameType: FrameType,
  preferredLayout?: EditToolLayoutValues,
  elementPosition?: TourStep['elementPosition']
) => {
  const initialConfig = buildDefaultTooltipConfigObject({
    xpath: !isLast ? xpath : undefined,
    frameType,
    preferredLayout,
  });

  return {
    content: DEFAULT_STEP_CONTENT,
    eventType: TourStepEventType.click,
    stepType: TourStepType.tooltip,
    xpath: !isLast ? xpath : '',
    elementPosition: xpath ? undefined : elementPosition,
    config: initialConfig,
  } as TourStep;
};
